// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__2i8pf","mainContent":"Details_mainContent__3T_zw","description":"Details_description__2WuFP","payBtn":"Details_payBtn__2puiV"};